import { useEffect, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import View from './pages/View';
import Planes from './pages/Planes';
import Spinner from './components/Spinner';
import Error from './components/Error';
import HomeData from './pages/HomeData';
import FormPago from './pages/FormPago';
import ConfirmationView from './pages/ConfirmationView';
import BeneficiaryData from './pages/BeneficiaryData';
import SuccessBenData from './components/SuccessBenData';
import SessionExpired from './components/SessionExpired';
import FormInfoUser from './pages/FormInfoUser';
import FrequentQuestions from './components/FrequentQuestion';
import ErrorBoundary from './components/ErrorBoundary'
import { Timer } from './components/Timer';
import { TecnologyData } from './pages/TecnologyData';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { setErrorEncrypt, setFirstStep, setParamsMus, setUserContainProduct } from './redux/reducer/stepReducer/stepReducer';
import { logIn } from './redux/reducer/stepReducer/thunks';
import { CODEMP_MUSIMUNDO, rotateDate, titleProducts } from './utilities';
import moment from 'moment';
import Bajas from './pages/Bajas';
import './styles.css';


const theme = createTheme({
  palette: {
    secondary: {
      main: '#ED1C24',
    },
    primary: {
      main: 'rgba(62, 62, 62, 1)',
    },
    button: {
      main: '#ffff',
    },
    buttoncustom: {
      main: 'rgba(232, 222, 248, 1)',
    },
    gray: {
      main: '#bbbdbd',
    },
    blue: {
      main: '#1c61ed',
      contrastText: '#ffffff'
    }
  },
});

function App() {
  const [allowSession, setAllowSession] = useState(false);
  const [message, setMessage] = useState('');
  const [icono, setIcono] = useState('');
  const [nomemp, setNomemp] = useState('');
  const { response, user, menu, existsToken } = useSelector(state => state.adminReducer.login);
  const login = useSelector(state => state.adminReducer.login);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const today = moment();
  const getLocalDateStorage = () => { return JSON.parse(localStorage.getItem('date')) || [] };

  console.log('login:', login)
  useEffect(() => {
    if (window.location.href.length < 150) {  //Verifica que envien el token al ingreso, 
      return navigate('/error');
    }
    //Envia el primer llamado a progress con los datos encriptados
    else dispatch(logIn());
  }, []);

  const verifyParamsReceived = (response) => {
    //Evalua la response del back y comprueba que vengan todos los parametros desde MUS y no haya vacíos.
    return (response.split(';')?.findIndex((e) => e === '') === -1 || response.split(';')?.findIndex((e) => e === '') === 2);
  };

  useEffect(() => {
    if (user?.login) {
      try {
        const allParams = verifyParamsReceived(response);
        if (allParams && !response.includes('error')) {
          const nro = response?.split(";")?.[0];
          if (!nro || Number(nro) === 0) {
            dispatch(setErrorEncrypt(true));
            navigate('/error');
          };
          const origen = response?.split(";")?.[1];
          localStorage.setItem('origin', JSON.stringify(origen));
          if (origen !== '99999' && origen !== '88888') {
            dispatch(setErrorEncrypt(true));
            return navigate('/error');
          };
          const product = response?.split(";")?.[2];
          const date = rotateDate(response?.split(";")?.[3]);
          dispatch(setParamsMus({ nro, origen, product, date: response?.split(";")?.[3] }))
          const timeAllowedSession = 1;
          if (existsToken === 'no') {
            const sessionInitializedSince = moment(date);
            let time = today.diff(sessionInitializedSince, 'minutes');
            if (time <= timeAllowedSession) {
              setAllowSession(true);
              localStorage.setItem('date', JSON.stringify(sessionInitializedSince._i));
              localStorage.setItem('firstStep', JSON.stringify({ nro, origen, date: response?.split(";")?.[3] }));
            }
            else {
              setAllowSession(false);
              return navigate('/expiracion');
            };
          } else {
            const dateStorage = getLocalDateStorage();
            if (dateStorage.length == 0) {
              dispatch(setErrorEncrypt(true));
              return navigate('/error');
            } else {
              const sessionInitializedSince = moment(dateStorage);
              let time = today.diff(sessionInitializedSince, 'minutes');
              if (time <= timeAllowedSession) {
                setAllowSession(true);
                localStorage.setItem('date', JSON.stringify(sessionInitializedSince._i));
                localStorage.setItem('firstStep', JSON.stringify({ nro, origen, date: response?.split(";")?.[3] }));
              }
              else {
                localStorage.removeItem('date');
                localStorage.removeItem('response');
                setAllowSession(false);
                return navigate('/expiracion');
              };
            }
          }
          const validProducts = ['19', '12', '62', '8', '159', '161'];
          //Todos los productos válidos de la web
          if (product) {
            if (validProducts.includes(product)) {
              dispatch(setFirstStep({ codsec: product, codcia: menu?.find((e) => e.codsec == product)?.codcia, title: titleProducts.find((e) => e.section == product)?.title }));
              localStorage.setItem('firstStep', JSON.stringify({ codsec: product, codcia: menu?.find((e) => e.codsec == product)?.codcia }));
              localStorage.removeItem('codpmpol');
              dispatch(setUserContainProduct(true));
              return navigate(`/${product}`);
            }
            else {
              return navigate(`/error`);
            }
          }
        }
      } catch (error) {
        setMessage('Hubo un error en el ingreso');
        navigate('/error');
      }
    }
  }, [user?.login]);

  useEffect(() => {
    if (login.payload?.error) {
      return navigate('/error');
    };
  }, [login]);

  useEffect(() => {
    if (login.codemp) {
      if (CODEMP_MUSIMUNDO.includes(login.codemp)) {
        setIcono("./assets/LOGOFAVICON.png");
        setNomemp('Musimundo');
      }
      else {
        setIcono("./assets/ISO-CFN.png");
        setNomemp('Crédito Argentino');
      }
    };
  }, [login]);


  return (
    <div className='testdiv'>
      <Helmet>
        <link rel="icon" type="image/svg+xml" href={icono || ''} />
        <title>Seguros {nomemp || ''}</title>
      </Helmet>
      <ThemeProvider theme={theme}>
        <ErrorBoundary fallback={<Error />}>
          <TransitionGroup>
            <CSSTransition key={location.key} classNames="fade" timeout={300}>
              <Timer>
                {
                  (login?.logged || login.payload?.error) ? (
                    <Routes>
                      <Route path="/" element={<Planes />} />
                      <Route path="/:id" element={<View />} />
                      <Route path="/planes" element={<Planes />} />
                      <Route path="/elegirPlan" element={<View />} />
                      <Route path="/datosTitular" element={<FormInfoUser />} />
                      <Route path="/datosTecnologia" element={<TecnologyData />} />
                      <Route path="/datosHogar" element={<HomeData />} />
                      <Route path="/datosBeneficiario" element={<BeneficiaryData />} />
                      <Route path="/detalleBeneficiario" element={<SuccessBenData />} />
                      <Route path="/pago" element={<FormPago />} />
                      <Route path="/confirmacion" element={<ConfirmationView />} />
                      <Route path="/error" element={<Error />} />
                      <Route path="/expiracion" element={<SessionExpired />} />
                      <Route path="/questions" element={<FrequentQuestions />} />
                    </Routes>
                  ) : (
                    window.location.href.length < 150 ?
                      <Error message={message} />
                      :
                      <Spinner />
                  )
                }
              </Timer>
            </CSSTransition>
          </TransitionGroup>
        </ErrorBoundary>
      </ThemeProvider>
    </div >
  );
}

export default App;